import { resource } from "./resource";

const cycles = resource("/performance/cycle");
const reviews = resource("/performance/review");
const goals = resource("/performance/goal");
const api = resource("/performance");

// ---- review cycles ----
export const getReviewCycles = async () => await cycles.get();
export const getReviewCycle = async (id) => await cycles.get(`/${id}`);
export const createReviewCycle = async (input = {}) => await cycles.post("", input);
export const updateReviewCycle = async (id, input = {}) => await cycles.put(`/${id}`, input);
export const activateReviewCycle = async (id) => await cycles.post(`/${id}/activate`);
export const closeReviewCycle = async (id) => await cycles.post(`/${id}/close`);
// reopening is audited server-side; the reason is required
export const reopenReviewCycle = async (id, reason) => await cycles.post(`/${id}/reopen`, { reason });
export const reopenReview = async (id, reason) => await reviews.post(`/${id}/reopen`, { reason });

// ---- reviews ----
export const getMyReviews = async () => await reviews.get("/mine");
export const getReviewsToDo = async () => await reviews.get("/to-review");
export const getReviewsByCycle = async (cycleId) => await reviews.get(`/by-cycle/${cycleId}`);
export const getReview = async (id) => await reviews.get(`/${id}`);
export const submitSelfReview = async (id, input = {}) => await reviews.post(`/${id}/self`, input);
export const submitManagerReview = async (id, input = {}) => await reviews.post(`/${id}/manager`, input);
export const finalizeReview = async (id) => await reviews.post(`/${id}/finalize`);

// ---- dashboard ----
export const getPerformanceAnalytics = async (cycleId) => await api.get("/analytics", { cycleId });

// ---- goals / KPIs ----
// org-wide goals for cycle planning (admin). Filters: reviewCycle, employee,
// status, unlinked=true
export const getAllGoals = async (params = {}) => await goals.get("", params);

export const getMyGoals = async () => await goals.get("/mine");
export const getEmployeeGoals = async (employeeId) => await goals.get(`/employee/${employeeId}`);
export const createGoal = async (input = {}) => await goals.post("", input);
export const updateGoal = async (id, input = {}) => await goals.put(`/${id}`, input);
export const deleteGoal = async (id) => await goals.del(`/${id}`);
